import React from 'react';
import PropTypes from 'prop-types';
import difference from 'lodash/difference';
import { orderBy } from 'natural-orderby';
import { SingleSelect, Fields } from 'smartsuite-ui';
import { useLabelContext } from '../hooks/labelContext';

// eslint-disable-next-line complexity
export function AdditionalFilterSelector(props) {
    const { dashboardLabels } = useLabelContext();

    const filterKeyOptions = difference(
        props.additionalFilterKeys,
        props.usedAdditionalFilterKeys
    );

    if (!filterKeyOptions.length) {
        return null;
    }

    const options = orderBy(filterKeyOptions).map((filterKey) => ({
        textField: props.availableFilters[filterKey].label,
        valueField: filterKey,
    }));

    return (
        <div>
            <Fields
                cssClassModifiers={[
                    'no-background',
                    'no-pad-top-bottom',
                    'no-wrap',
                    props.isEditor ? 'column' : '',
                ]}
            >
                <SingleSelect
                    menuPortalTarget={props.isEditor ? document.body : null}
                    onChange={props.handleAdditionalFilterSelect}
                    options={options}
                    placeholder={dashboardLabels.addFilter}
                    styles={{
                        menuPortal: (styles) => ({
                            ...styles,
                            zIndex: 10,
                        }),
                    }}
                    textField="textField"
                    valueField="valueField"
                    value=""
                />
            </Fields>
        </div>
    );
}

AdditionalFilterSelector.propTypes = {
    additionalFilterKeys: PropTypes.instanceOf(Array).isRequired,
    availableFilters: PropTypes.instanceOf(Object).isRequired,
    handleAdditionalFilterSelect: PropTypes.func.isRequired,
    isEditor: PropTypes.bool.isRequired,
    usedAdditionalFilterKeys: PropTypes.instanceOf(Array).isRequired,
};
